import { render, staticRenderFns } from "./internalResourceImage2.vue?vue&type=template&id=525cb37a&scoped=true"
import script from "./internalResourceImage2.vue?vue&type=script&lang=js"
export * from "./internalResourceImage2.vue?vue&type=script&lang=js"
import style0 from "./internalResourceImage2.vue?vue&type=style&index=0&id=525cb37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525cb37a",
  null
  
)

export default component.exports